import axios from "axios";
import {api, apiAuth} from '../../../services/ApiService';
import {createRequest} from '../../../helpers/RequestHelper';
import {downloadArquivoAjax} from '../../../helpers/Downloads';
import getAddressByCEP from "../../../helpers/SoapCep";

// http://192.168.24.119:9000/api/forms?access=231.444.123-21&size=1&page=5
export function buscarFormulariosPorCPFPorPagina(url, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: url, onSuccess, onError
    });
}

export function buscarTodosOsModelosCertificadoPorForm(idForm, onSuccess, onError) {
    const path = `/certificados/modelos?pageable=false&idForm=${idForm}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function liberarMulticertificado(data, onSuccess, onError) {
    const path = `/certificados/liberar/multi`
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data, onSuccess, onError
    });
}

export function liberarCertificadoUnido(data, onSuccess, onError) {
    const path = `/certificados/liberar/unico`
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data, onSuccess, onError
    });
}
export function atualizarCertificadoUnido(data, onSuccess, onError) {
    const path = `/certificados/liberar/unico`
    return createRequest({
        api: apiAuth, method: 'PUT', path: path, data, onSuccess, onError
    });
}
export function downloadCertificado(idDadosCertificado, onSuccess, onError) {
    const path = `/certificados/download/${idDadosCertificado}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}


export function dadosCertificadosPorModelo(idModelo, onSuccess, onError) {
    const path = `/certificados/dados/modelo/${idModelo}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function dadosCertificadosPorCampo(idFormulario, idCampo, onSuccess, onError) {
    const path = `/certificados/dados/formulario/${idFormulario}/campo/${idCampo}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function buscarFormulario(id, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: '/forms/'+id, onSuccess, onError
    });
}

export function buscarFormularioAtivo(id, onSuccess, onError) {
    return createRequest({
        api: api, method: 'GET', path: '/forms/active/'+id, onSuccess, onError
    });
}

export function buscarFormularioAtivoInterno(id, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: '/forms/internos/'+id, onSuccess, onError
    });
}

export function buscarSubmissoesPorCPF(cpf, onSuccess, onError) {
    const path = `/submits?access=${cpf}`
    return createRequest({
        api: api, method: 'GET', path: path, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/submits/forms/36?size=10&page=0
export function buscarInscritosDeUmFormPorPagina(idForm, n_itens, pagina, campo_filtro, onSuccess, onError) {
    n_itens =  n_itens < 10 ? 10 : n_itens
    const path = `/submits/forms/${idForm}/?size=${n_itens}&page=${pagina - 1}&filtro=${campo_filtro}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path , onSuccess, onError
    });
}

export function buscarInscritosDeUmForm(url, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: url , onSuccess, onError
    });
}

// 192.168.24.119:9000/api/submits/academico?cpf={cpf}&tipo={Tipo}
export function buscarDadosInscricaoPorCPFETipo(cpf, tipo, onSuccess, onError){
    const path = `/submits/academico?cpf=${cpf}&tipo=${tipo}`
    return createRequest({
        api: api, method: 'GET', path: path, onSuccess, onError
    });
}

export function enviarSubmissao(idForm, data, onSuccess, onError) {
    return createRequest({
        api: api, method: 'POST', path: '/submits/'+idForm, data: data, onSuccess, onError
    });
}

export function enviarReSubmissao(idSubmissao, idForm, data, onSuccess, onError) {
    return createRequest({
        api: api, method: 'PUT', path: '/submits/'+idSubmissao+'/forms/'+idForm, data: data, onSuccess, onError
    });
}

//Internos
export function enviarSubmissaoInterna(idForm, data, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'POST', path: '/submits/internos/'+idForm, data: data, onSuccess, onError
    });
}

export function enviarReSubmissaoInterna(idSubmissao, idForm, data, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'PUT', path: '/submits/internos/'+idSubmissao+'/forms/'+idForm, data: data, onSuccess, onError
    });
}
//

// Informações obre o form, pagina Home
export function getInformacoesDoForm(id, onSuccess, onError) {
    const path = `/submits/info/${id}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

// verificar se submissão tem certificado liberado para download
// http://192.168.24.119:9000/api/certificados?sub=175
export function getInformacoesDeCertificadoDisponivel(id, onSuccess, onError) {
    const path = `/certificados?sub=${id}`
    return createRequest({
        api: api, method: 'GET', path: path, onSuccess, onError
    });
}

// lista com os campos que não tem seus dados fixos preenchidos
// http://192.168.24.119:9000/api/certificados/fixos/list?idForm=103&listCampos=0,3,4 
export function getInformacoesDeDadosFixosNaoCadastradosDeCertificado(idForm, listaDeCampos, onSuccess, onError) {
    const path = `/certificados/fixos/list?idForm=${idForm}&listCampos=${listaDeCampos}`
    return createRequest({
        api: apiAuth, method: 'GET', path, onSuccess, onError
    });
}

// Download
export function uploadArquivo(data, idForm, cpf, onSuccess, onError){
    return createRequest({
        api: api, method: 'POST', path: '/submits/files/upload/'+idForm+'?access='+cpf, data: data, onSuccess, onError
    });
}

// localhost:9000/api/submits/download/csv/{id}
export function downloadListaInscritosFormularioCSV(idForm, onSuccess, onError){
    const path = `/submits/download/csv/${idForm}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path , onSuccess, onError
    })
}

// localhost:9000/api/submits/download/pdf/{id}
export function downloadListaInscritosFormularioPDF(idForm, onSuccess, onError){
    const path = `/submits/download/pdf/${idForm}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path , onSuccess, onError
    })
}

// localhost:9000/api/submits/download/pdf/comprovante/{idSubmissao}?title={titulo do comprovante}
export function downloadComprovanteInscricao(idSubmissao, onSuccess, onError){
    const path = `/submits/download/pdf/comprovante/${idSubmissao}?title=Comprovante de Inscrição`
    return createRequest({
        api: api, method: 'GET', path: path , onSuccess, onError
    })
}

// localhost:9000/api/submits/download/pdf/comprovante/{idSubmissao}?title={titulo do comprovante}
export function downloadDadosInscricao(idSubmissao, onSuccess, onError){
    const path = `/submits/download/pdf/comprovante/${idSubmissao}?title=Dados da Inscrição`
    return createRequest({
        api: api, method: 'GET', path: path , onSuccess, onError
    })
}

// localhost:9000/api/submits/{id}/boleto
export function downloadBoleto(idSubmissao, data, onSuccess, onError){
    const path = `/submits/${idSubmissao}/boleto`
    return createRequest({
        api: api, method: 'POST', path: path , onSuccess, onError, data: data
    })
}

// localhost:9000/api/submits/files/download?path=form_77/submit_111.111.111-11/17554079_1018576124940492_235338671282961878_n.jpg
export function downloadArquivo(idForm, cpf, filePath, onSuccess, onError){
    const path = `/submits/files/download/${idForm}?fileName=${filePath}&access=${cpf}`
    downloadArquivoAjax(process.env.REACT_APP_URL_API + path, onSuccess, onError)
}
// export function downloadArquivo(idForm, cpf, filePath, onSuccess, onError){
//     const path = `/submits/files/download/${idForm}?fileName=${filePath}&access=${cpf}`
//     return createRequest({
//         api: apiAuth, method: 'GET', path: path , onSuccess, onError
//     })
// }

// localhost:9000/api/certificados/download?cpf={cpf}&idForm={idForm}
// export function downloadCertificados(cpf, idForm){
//     //const path = `/certificados/download?cpf=${cpf}&idForm=${idForm}`
//     const path = `/certificados/download?cpf=${cpf}&idForm=41`
//     downloadArquivoAjax(process.env.REACT_APP_URL_API + path)
// }

//localhost:9000/api/submits/replace?cpf={cpf}&form={idForm}
export function verificaResubmissao(idForm, cpf, onSuccess, onError){
    const path = `/submits/replace?cpf=${cpf}&form=${idForm}`;
    return createRequest({
        api: api, method: 'GET', path: path, onSuccess, onError
    });
}

//localhost:9000/api/submits/files/folder?path={path}
export function apagarArquivosSubmissao(idForm, cpf, onSuccess, onError){
    const path = `form_${idForm}/submit_${cpf}`;
    return createRequest({
        api: api, method: 'DELETE', path: '/submits/files/folder?path='+path, onSuccess, onError
    });
}

export function apagarSubmissao(id, onSuccess, onError){
    const path = `/submits/${id}`;
    return createRequest({
        api: api, method: 'DELETE', path: path, onSuccess, onError
    });
}

export function buscaCEP(cep, onSuccess, onError){
    let api = axios.create({baseURL: 'https://viacep.com.br'});
    const path = `/ws/${cep}/json/`
    return createRequest({
        api: api, method: 'GET', path, onSuccess, onError
    });
}

export function consultaCEP(cep, onSuccess, onError) {
    const url =
      "https://cors-anywhere.herokuapp.com/https://apps.correios.com.br/SigepMasterJPA/AtendeClienteService/AtendeCliente?wsdl";
    return getAddressByCEP(cep, url).then(onSuccess, onError);
  }
  

export function confirmacaoPorEmail(id, dataMaxima, onSuccess, onError) {
    const path = `/forms/${id}/email/confirmar`
    const data = {dataMaxima} 
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data, onSuccess, onError
    });
}

export function alterarDataLimiteConfirmacaoEmail(id, dataMaxima, onSuccess, onError) {
    const path = `/forms/${id}/email/confirmar`
    const data = {dataMaxima} 
    return createRequest({
        api: apiAuth, method: 'PUT', path: path, data, onSuccess, onError
    });
}

export function enviarComunicadoPorEmail(id, comunicado, onSuccess, onError) {
    const path = `/forms/${id}/email/comunicado`
    const data = {comunicado}
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data, onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/formulario/actions/FormActions.js